import AlbumPurchasedCustomPrintDetailsView from './AlbumPurchasedCustomPrintDetailsView';
import AlbumPurchasedCustomPrintDetailsModal from './modal';

export { AlbumPurchasedCustomPrintDetailsModal };

export default AlbumPurchasedCustomPrintDetailsView;
